import { CycleStageName, ReviewType } from './models';
import { VacationTypeEnum } from './enums/vacation-type.enum';
import { TravelRequestTemplateType } from './enums/travel-request-template-type.enum';

export const DEFAULT_AVATAR_URL = '/assets/img/defaultAvatar.png';

export const NO_ACCESS_ROUTE = '/no-access';

export const IT_SUPPORT_PORTAL_URL =
  'https://dreamix-it.atlassian.net/servicedesk/customer/portal/1';

export const OFFICE_SUPPORT_PORTAL_URL =
  'https://dreamix-it.atlassian.net/servicedesk/customer/portal/3';

export const DIALOG_BUTTONS = {
  cancelButton: 'cancelButton',
  warningButton: 'warningButton',
  deleteButton: 'deleteButton',
  successButton: 'successButton',
  saveButton: 'saveButton',
};

type CreateReviewMenuItemType = {
  label: string;
  routerLink: string | null;
};

export const CreateReviewMenuItems: CreateReviewMenuItemType[] = [
  {
    label: 'ADMIN.REVIEW_CYCLES.TYPE.REVIEW',
    routerLink: '/admin/feedback/review-cycles/' + ReviewType.REVIEW_CYCLE.toLowerCase(),
  },
  // {
  //   label: 'ADMIN.REVIEW_CYCLES.TYPE.SURVEY',
  //   routerLink: null,
  // },
  {
    label: 'ADMIN.REVIEW_CYCLES.TYPE.PROBATION_REVIEW',
    routerLink: '/admin/feedback/review-cycles/probation/probation-cycle-name',
  },
];

export const reviewTypeToRoute = {
  [ReviewType.REVIEW_CYCLE]: 'review',
  [ReviewType.PROBATION_REVIEW]: 'probation',
};

export const probationStageNameToRoute = {
  [CycleStageName.NAME]: 'probation-cycle-name',
  [CycleStageName.PARTICIPANTS_SELECTION]: 'probation-cycle-reviewee-selection',
  [CycleStageName.EMPLOYEE_SELECTION]: 'probation-cycle-reviewers-selection',
  [CycleStageName.TEMPLATE_ASSIGNMENT]: 'probation-cycle-templates',
  [CycleStageName.PHASES_SCHEDULE]: 'probation-cycle-phases',
};

export const REIMBURSEMENT_TYPES = {
  travel: 'Travel',
  sport: 'Sport',
  dentist: 'Dentist',
  tooling: 'Tooling',
};

export const VACATION_TYPES = [
  'VACATION',
  'OTHER_PAID_LEAVE',
  'MATERNITY_PATERNITY',
  'LEAVE_OF_ABSENCE',
  'WORK_ON_HOLIDAYS',
  'SICK_LEAVE',
] as const;
export type VacationType = (typeof VACATION_TYPES)[number];

export const VACATION_ICONS = {
  VACATION: 'beach_access',
  OTHER_PAID_LEAVE: 'monetization_on',
  MATERNITY_PATERNITY: 'stroller',
  LEAVE_OF_ABSENCE: 'money_off',
  WORK_ON_HOLIDAYS: 'work',
  SICK_LEAVE: 'sick',
} as const satisfies Record<VacationType, string>;

export const VACATION_TYPE_TITLE_TO_KEY: Partial<Record<string, VacationType>> = {};

for (const [key, title] of Object.entries(VacationTypeEnum)) {
  VACATION_TYPE_TITLE_TO_KEY[title] = key as VacationType;
}

export const VACATION_SICK_TYPES = ['REGULAR_SICK_LEAVE', 'DREAMIX_SICK_LEAVE'] as const;
export type VacationSickType = (typeof VACATION_SICK_TYPES)[number];

export const VACATION_PAID_TYPES = [
  'REGULAR_SICK_LEAVE',
  'DREAMIX_SICK_LEAVE',
  'MARRIAGE',
  'BLOOD_DONATION',
  'RELATIVE_DEATH',
  'COURT_HEARING',
  'MEMBER_OF_GOVERNMENT_MEETING',
  'TRAINING_FOR_DISASTER_SITUATION',
  'EMPLOYER_NOTICE_FOR_DISMISSAL',
  'OTHER_PROJECT',
] as const;
export type VacationPaidType = (typeof VACATION_PAID_TYPES)[number];

export type VacationSubType = VacationPaidType | VacationSickType;

export const CALENDAR_LEAVE_TYPES = [
  'VACATION',
  'OTHER_PAID_LEAVE',
  'MATERNITY_PATERNITY',
  'LEAVE_OF_ABSENCE',
  'WORK_ON_HOLIDAYS',
  'REGULAR_SICK_LEAVE',
  'DREAMIX_SICK_LEAVE',
] as const;
export type CalendarLeaveType = (typeof CALENDAR_LEAVE_TYPES)[number];

export const LEAVE_TYPE_ICONS = {
  ...VACATION_ICONS,
  REGULAR_SICK_LEAVE: 'sick',
  DREAMIX_SICK_LEAVE: 'medication',
} as const satisfies Record<VacationType | CalendarLeaveType, string>;

export const toCalendarLeaveType = (
  vacationType: VacationType,
  subType?: string,
): CalendarLeaveType => {
  if (vacationType !== 'SICK_LEAVE') {
    return vacationType;
  }

  return subType === 'DREAMIX_SICK_LEAVE' ? 'DREAMIX_SICK_LEAVE' : 'REGULAR_SICK_LEAVE';
};

export const PERMISSIONS_PROPERTY_NAME = 'permissions';

export const DEFAULT_PAGE_SIZE = 10;
export const SEARCH_DEBOUNCE_MS = 300;
export const AUTOSAVE_DEBOUNCE_MS = 1500;

export const TRAVEL_REQUEST_TEMPLATE_LABEL_KEYS: Record<TravelRequestTemplateType, string> = {
  [TravelRequestTemplateType.BULGARIA]: 'ADMIN.TRAVEL_REQUESTS.TEMPLATES.BULGARIA_SECTION',
  [TravelRequestTemplateType.ABROAD]: 'ADMIN.TRAVEL_REQUESTS.TEMPLATES.ABROAD_SECTION',
};
